export const MAP_CONTINENT_CODE_TO_COUNTRY_CODE = {
    // Asia = Singapore
    AS: 'sg',
    // Europe = Great Britain
    EU: 'gb',
    // North America = United States
    NA: 'en-us',
    // Oceania = Australia
    OC: 'au',
    // South America = Argentina
    SA: 'ar'
};
export const MAP_COLLABORATION_LANG_TO_COUNTRY_CODE = {
    // Arabian = Saudi Arabia
    ar: 'sa',
    // Catalan
    ca: 'cat',
    // Dansk = Denmark
    da: 'dk'
};
